module.exports = __webpack_public_path__ + "img/avatar0.edfa71c3.png";